import axios from "axios";

const {
    REACT_APP_BASE_URL,
    REACT_APP_FUNCTION_KEY,
} = process.env;

const CommentService = {
    /*
     [RG] Add Comment To Document
    */
    AddComment: async ({token, data, documentId, params = null }) => {
        try {
            const response = await axios.post(`${REACT_APP_BASE_URL}/notes/${documentId}`,
                   data,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-functions-key": REACT_APP_FUNCTION_KEY,
                        Authorization: `Bearer ${token}`,
                    },
                    params: params,
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching documents:", error);
            throw error;
        }
    },
    AddBulkComments: async ({token, data, params = null }) => {
        try {
            const response = await axios.post(`${REACT_APP_BASE_URL}/notes/bulk`,
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-functions-key": REACT_APP_FUNCTION_KEY,
                        Authorization: `Bearer ${token}`,
                    },
                    params: params,
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error Adding Bulk Comments:", error);
            throw error;
        }
    },
};

export default CommentService;